export const categories = {
    People: [
        "Negotiations and Deal Making",
        "Internal Interactions",
        "Cross Cultural Engagements",
        "Dynamic Presence",
        "External Interactions",
    ],
    percentagePeople: 0,
    Numerical: [
        "Numerical & Quantitative Aptitutde",
        "Resource Management",
        "Recruitment and Support",
        "Monitoring, Inspecting and Testing",
        "Social Initiatives and Impact"
    ],
    percentageNumerical: 0,
    ManagerialandAdministrative: [
        "Project Management",
        "Administration",
        "Leadership",
        "Resource Management",
        "Continuous Learning & Upskilling"
    ],
    percentageManagerialandAdministrative: 0,
    Creative: [
        "Creation and Innovation",
        "Marketing & Promotions",
        "Design & Visualization",
        "Negotiations and Deal Making",
        "Subject Matter Expertise"
    ],
    percentageCreative: 0,
    ProcessandPlanning: [
        "Operations & Process Excellence",
        "Critical Thinking and Problem Solving",
        "R&D, Testing & Empirical Analysis",
        "Cross Cultural Engagements",
        "Social Initiatives and Impact"
    ],
    percentageProcessandPlanning: 0,
}

export const softSkill = {
    communication: [
        "Negotiations and Deal Making",
        "Internal Interactions",
        "Marketing & Promotions",
        "Social Initiatives and Impact",
        "Cross Cultural Engagements",
    ],
    percentagecommunication: 0,
    AttentionToDetail: [
        "Numerical & Quantitative Aptitutde",
        "Operations & Process Excellence",
        "Critical Thinking and Problem Solving",
        "R&D, Testing & Empirical Analysis",
        "Dynamic Presence"
    ],
    percentageAttentionToDetail: 0,
    adaptability: [
        "Dynamic Presence",
        "Cross Cultural Engagements",
        "Design & Visualization",
        "Monitoring, Inspecting and Testing",
        "Continuous Learning & Upskilling"
    ],
    percentageadaptability: 0,
    criticalThinking: [
        "Numerical & Quantitative Aptitutde",
        "Recruitment and Support",
        "Social Initiatives and Impact",
        "R&D, Testing & Empirical Analysis",
        "Critical Thinking and Problem Solving"
    ],
    percentagecriticalThinking: 0,
    teamwork: [
        "Internal Interactions",
        "Project Management",
        "Administration",
        "External Interactions",
        "Cross Cultural Engagements"
    ],
    percentageteamwork: 0,
    interpersonalSkills: [
        "Negotiations and Deal Making",
        "Internal Interactions",
        "Dynamic Presence",
        "External Interactions",
        "Cross Cultural Engagements"
    ],
    percentageinterpersonalSkills: 0,
    decisionMaking: [
        "Recruitment and Support",
        "R&D, Testing & Empirical Analysis",
        "Design & Visualization",
        "Administration",
        "Resource Management"
    ],
    percentagedecisionMaking: 0,
    empathy: [
        "Internal Interactions",
        "External Interactions",
        "Leadership",
        "Dynamic Presence",
        "Cross Cultural Engagements"
    ],
    percentageempathy: 0,
    persuasion: [
        "Negotiations and Deal Making",
        "Marketing & Promotions",
        "Social Initiatives and Impact",
        "Cross Cultural Engagements",
        "Subject Matter Expertise"
    ],
    percentagepersuasion: 0,
    timeManagement: [
        "Project Management",
        "Administration",
        "Operations & Process Excellence",
        "Marketing & Promotions",
        "Resource Management"
    ],
    percentagetimeManagement: 0,
}

export const targetJobs = {
    "Marketing Manager": {
        skill: [
            "Negotiations and Deal Making",
            "External Interactions",
            "Marketing and Promotions",
            "Cross Cultural Engagements",
        ],
        percentage: 0,
        explanation: "Manages marketing campaigns, develops strategies to generate demand, negotiates deals, and builds relationships with international and national partners."
    },
    "Operations Manager": {
        skill: [
            "Internal Interactions",
            "Operations & Process Excellence",
            "Project Management",
            "Resource Management",
            "Dynamic Presence"
        ],
        percentage: 0,
        explanation: "Oversees daily operations, ensures process efficiency, manages projects and resources, and engages in fieldwork."
    },
    "Financial Analyst": {
        skill: [
            "Numerical & Quantitative Aptitutde",
            "Critical Thinking and Problem Solving",
            "Recruitment and Support",
            "Resource Management",
            "Analytics, Research & Insights"
        ],
        percentage: 0,
        explanation: "Analyses financial data, solves financial problems, ensures regulatory compliance, and conducts empirical analysis for financial research."
    },

    "Human Resources (HR) Manager": {
        skill: [
            "Internal Interactions",
            "Administration",
            "Leadership",
            "Self Management and Development",
            "Monitoring, Inspecting and Testing"
        ],
        percentage: 0,
        explanation: "Manages HR functions, oversees employee relations, develops leadership programs, and promotes sustainable HR practices."
    },
    "Project Manager": {
        skill: [
            "Resource Management",
            "Project Management",
            "Critical Thinking and Problem Solving",
            "Leadership",
            "Analytics, Research & Insights"
        ],
        percentage: 0,
        explanation: "Plans and executes projects, manages resources, solves project issues, leads project teams, and conducts R&D for project innovation."
    },

    "Compliance Manager": {
        skill: [
            "Recruitment and Support",
            "Numerical & Quantitative Aptitutde",
            "Critical Thinking and Problem Solving",
            "Administration",
            "Social Initiatives and Impact"
        ],
        percentage: 0,
        explanation: "Ensures compliance with regulations, manages compliance policies, solves compliance-related issues, and handles CSR initiatives."
    },
    "Business Development Manager": {
        skill: [
            "Demand Generation",
            "External Interactions",
            "Deal Making & Negotiations",
            "Marketing and Promotions",
            "Cross Cultural Engagements"
        ],
        percentage: 0,
        explanation: "Identifies business opportunities, generates leads, negotiates deals, and manages client relationships."
    },
    "Environmental Sustainability Manager": {
        skill: [
            "Monitoring, Inspecting and Testing",
            "Operations & Process Excellence",
            "Recruitment and Support",
            "Critical Thinking and Problem Solving",
            "Resource Management"
        ],
        percentage: 0,
        explanation: "Develops sustainability initiatives, ensures regulatory compliance, solves environmental issues, and manages sustainable resources."
    },
    "Product Manager": {
        skill: [
            "Creation and Innovation, Design & Visualization",
            "Critical Thinking and Problem Solving",
            "Analytics, Research & Insights",
            "Subject Matter Expertise"
        ],
        percentage: 0,
        explanation: "Manages product development, ensures innovation, designs product features, solves product issues, and conducts R&D."
    },
    "Corporate Social Responsibility (CSR) Manager": {
        skill: [
            "Social Initiatives and Impact",
            "External Interactions",
            "Recruitment and Support",
            "Monitoring, Inspecting and Testing",
            "Leadership"
        ],
        percentage: 0,
        explanation: "Manages CSR initiatives, engages with stakeholders, ensures compliance with CSR policies, and leads sustainability projects."
    },
    "Sales Manager": {
        skill: [
            "Demand Generation",
            "Deal Making & Negotiations",
            "Marketing and Promotions",
            "External Interactions",
            "Resource Management"
        ],
        percentage: 0,
        explanation: "Manages sales strategies, generates demand, negotiates deals, and oversees marketing efforts."
    },
    "Customer Service Manager": {
        skill: [
            "Critical Thinking and Problem Solving",
            "Administration",
            "Leadership",
            "Internal Interactions",
            "Self Management and Development"
        ],
        percentage: 0,
        explanation: "Manages customer service operations, solves customer issues, administers service policies, and develops training programs."
    },
    "Supply Chain Manager": {
        skill: [
            "Resource Management",
            "Operations & Process Excellence",
            "Numerical & Quantitative Aptitutde",
            "Project Management",
            "Dynamic Presence"
        ],
        percentage: 0,
        explanation: "Manages supply chain operations, ensures process efficiency, analyzes supply chain data, and engages in fieldwork."
    },
    "Research and Development (R&D) Manager": {
        skill: [
            "Analytics, Research & Insights",
            "Creation and Innovation",
            "Critical Thinking and Problem Solving",
            "Subject Matter Expertise",
            "Design & Visualization"
        ],
        percentage: 0,
        explanation: "Oversees R&D projects, ensures innovation, solves research issues, and designs research methodologies."
    },
    "Training and Development Manager": {
        skill: [
            "Self Management and Development",
            "Administration",
            "Leadership",
            "Internal Interactions",
            "Monitoring, Inspecting and Testing"
        ],
        percentage: 0,
        explanation: "Manages training programs, administers development policies, leads training initiatives, and promotes sustainable practices."
    },
    "Digital Marketing Manager": {
        skill: [
            "Marketing and Promotions",
            "Creation and Innovation",
            "Demand Generation",
            "Deal Making & Negotiations",
            "International and National Relationships"
        ],
        percentage: 0,
        explanation: "Manages digital marketing campaigns, generates demand, negotiates digital deals, and builds international relationships."
    },
    "Facilities Manager": {
        skill: [
            "Administration",
            "Operations & Process Excellence",
            "Resource Management",
            "Recruitment and Support",
            "Dynamic Presence"
        ],
        percentage: 0,
        explanation: "Manages facilities operations, ensures process efficiency, administers facilities policies, and engages in fieldwork."
    },
    "Quality Assurance Manager": {
        skill: [
            "Operations & Process Excellence",
            "Critical Thinking and Problem Solving",
            "Analytics, Research & Insights",
            "Recruitment and Support",
            "Numerical & Quantitative Aptitutde"
        ],
        percentage: 0,
        explanation: "Ensures quality standards, solves quality issues, conducts empirical analysis, and ensures regulatory compliance."
    },
    "Event Manager": {
        skill: [
            "External Interactions",
            "Project Management",
            "Resource Management",
            "Creation and Innovation",
            "Marketing and Promotions"
        ],
        percentage: 0,
        explanation: "Manages event planning, ensures resource allocation, generates event ideas, and oversees marketing efforts."
    },
    "Public Relations Manager": {
        skill: [
            "International and National Relationships",
            "External Interactions",
            "Negotiations and Deal Making",
            "Marketing and Promotions",
        ],
        percentage: 0,
        explanation: "Manages public relations campaigns, builds relationships, generates demand, negotiates media deals, and oversees marketing efforts."
    },
    "Business Analyst": {
        skill: [
            "Internal Interactions",
            "Numerical & Quantitative Aptitutde",
            "Critical Thinking and Problem Solving",
            "Operations & Process Excellence",
            "Analytics, Research & Insights"
        ],
        percentage: 0,
        explanation: "Analyses business data, solves business problems, ensures process efficiency, and conducts empirical analysis for business improvement."
    },
    "Market Research Manager": {
        skill: [
            "Negotiations and Deal Making",
            "Numerical & Quantitative Aptitutde",
            "Critical Thinking and Problem Solving",
            "Operations & Process Excellence",
            "Creation and Innovation"
        ],
        percentage: 0,
        explanation: "Analyzes market data to identify trends, solves complex market challenges, develops strategies to generate demand, negotiates deals, and ensures research processes are efficient while applying innovative approaches to stay ahead of industry trends."
    },
};